import { Box, Button, ButtonNew, Icon, Spacer } from '@jfs/ui-new'
import { DropdownTypes } from '../../comps//DropdownNew/types'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { settlementFileOptionsExport } from '../../data/static/data'
import { tableItemStrings } from '../../data/static/strings'
import { ActionType } from './types'

const getActionView = (
  text: string,
  executeAction: (actionType: ActionType) => void,
  disabled?: boolean,
  hide?: boolean,
  from?: string,
  onDownloadFileAction?: (fileType: string) => void,
) => {
  const removeSettlement = () => {
    executeAction(ActionType.RemoveSettlement)
  }

  const handleAction = () => {
    executeAction(ActionType.DownloadSettlementCSV)
  }

  const onPress = () => {
    executeAction(ActionType.Delete)
  }

  const split = text?.toString().split(',') ?? ''
  let value, iconValue
  if (!!split && split?.length > 0) {
    value = split[0]
    if (split?.length === 2) {
      iconValue = split[1]
    }
  }
  if (value === tableItemStrings.DELETE) {
    return (
      <Button onPress={removeSettlement} testID="btn-removeSettlement" color={'ERROR'} type={'IconLH'}>
        {tableItemStrings.deleteCaps}
      </Button>
    )
  }

  const handleOnChange = (data: string | number[]): void => {
    console.log('handleOnChange', data)
  }

  const handleDownload = (fileType: string) => {
    if (onDownloadFileAction) {
      onDownloadFileAction(fileType)
    }
  }

  if (value === 'EXPORT') {
    if (hide) {
      return <Spacer direction={'vertical'} size={50} />
    }
    return (
      <DropdownOptimised
        placeHolder={'Download'}
        buttonLabel="Download Now"
        data={settlementFileOptionsExport}
        onChange={handleOnChange}
        onButtonPress={handleDownload}
        type={DropdownTypes.RADIO_BUTTON}
        testID={'downloadInListItem'}
      />
    )
  }

  return (
    <Box flexDirection={'row'}>
      <ButtonNew
        disabled={
          value === tableItemStrings.refunded ||
          value === tableItemStrings.canceled ||
          value === ' Download' ||
          disabled
        }
        onPress={handleAction}
        type={'textWithIcon'}
        icon={value?.toLowerCase() === 'download' || value?.toLowerCase() === ' download' ? 'DOWNLOAD' : undefined}
        hide={value === '' || hide}
        title={value}
        testID={'downloadActionView'}
      />
      {!!iconValue && <Spacer direction={'horizontal'} size={8} />}
      {!!iconValue && (
        <Box onPress={onPress} testID="delete-item">
          <Icon id={'DELETE'} />
        </Box>
      )}
    </Box>
  )
}

export { getActionView }
